<template>
  <a-modal v-model="visible" :closable="false" :mask="false" centered :footer="null" width="80%">
    <Title title="TALK TO US"></Title>
    <div class="message-body" :style="backgroundImg">
      <a-row :gutter="[48,8]" class="message-form">
        <a-col :lg="{span: 12}">
          <a-spin :spinning="loading">
            <a-form-model ref="ruleForm" class="form-label-none" :model="formData" :rules="rules">
              <a-form-model-item label="firstName" prop="firstName">
                <a-input v-model="formData.firstName" :placeholder="$root.language.homeRow22" />
              </a-form-model-item>

              <a-form-model-item label="lastName" prop="lastName">
                <a-input v-model="formData.lastName" :placeholder="$root.language.homeRow23" />
              </a-form-model-item>

              <a-form-model-item label="email" prop="email">
                <a-input v-model="formData.email" :placeholder="$root.language.homeRow24" />
              </a-form-model-item>

              <a-form-model-item label="company" prop="company">
                <a-input v-model="formData.company" :placeholder="$root.language.homeRow25" />
              </a-form-model-item>
              <a-form-model-item label="job" prop="job">
                <a-input v-model="formData.job" :placeholder="$root.language.homeRow27" />
              </a-form-model-item>
            </a-form-model>

            <div class="text-left font-16 text-required">
              * {{$root.language.homeRow29}}
            </div>

          </a-spin>
        </a-col>

        <a-col :lg="{span: 12}">
          <a-textarea
            v-model="formData.description"
            :placeholder="$root.language.homeRow28"
            :rows="10"
          />
          <div class="text-right message-img">
            <span class="font-16 message-foot-text">{{$root.language.homeRow30}}</span>
            <img @click="jumpLink('wechat')" src="@/assets/img/wechat.jpg" width="55" alt="">
            <img @click="jumpLink('in')" src="@/assets/img/in.jpg" class="margin-left-15" width="55" alt="">
          </div>
        </a-col>

        <a-col :lg="{span: 24}">
        <div class="button-register font-16 text-center">
          <SkewButton :text="$root.language.homeRow26" width="180" class="text-center weight-bold font-16"
            @click="handleSubmit"></SkewButton>
        </div>
      </a-col>
      </a-row>
    </div>
  </a-modal>
</template>

<script>
import Title from '@/components/title'
import SkewButton from '@/components/button-skew'
import {
  createApi
} from '@/api/user'

import Tools from '@/utils/validate'
export default {
  components: {
    Title,
    SkewButton
  },

  data () {
    return {
      rules: {
        firstName: [{
          required: true,
          message: 'Please input',
          trigger: 'blur'
        }],
        lastName: [{
          required: true,
          message: 'Please input',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: 'Please input',
          trigger: 'blur'
        },
        {
          validator: Tools.email,
          trigger: 'change',
          message: 'Email is error'
        }
        ],
        company: [{
          required: false,
          message: 'Please input',
          trigger: 'blur'
        }]
      },
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        company: '',
        job: '',
        description: ''
      },
      backgroundImg: {
        backgroundImage: `url(${require('@/assets/img/bar.jpg')})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center'
      },
      loading: false,
      visible: false
    }
  },

  methods: {
    show () {
      this.visible = true
    },
    handleSubmit () {
      this.fetchTest()
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.fetchCreate()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    fetchTest () {
      this.$http({ method: 'get', url: 'http://gateway.jwis.cn/jic-i18n/i18nLanguageSet/searchI18nLanguageSet' }).then(data => {
        console.log(data)
      })
    },

    resetForm () {
      this.loading = false
      this.$refs.ruleForm.resetFields()
    },

    fetchCreate () {
      this.$http({
        ...createApi,
        data: this.formData
      }).then(() => {
        this.$message.success('success')
        this.resetForm()
        this.visible = false
      }).catch(err => {
        this.loading = false
        this.$message.error(err.msg)
      })
    },
    jumpLink (type) {
      if (type === 'in') {
        window.open('https://www.linkedin.com/company/3519789/')
      } else {
        window.open('https://mp.weixin.qq.com/s/kfaiJ3F_hUTJYKmKurIbvA')
      }
    }
  }
}

</script>

<style scoped>
  .message-body {
    margin-top: 50px;
    padding: 30px 100px;
  }
  .message-form {
    background-color: #e8e2e2;
    padding: 30px 15px;
    opacity: 0.9;
  }
  .message-img {
    margin-top: 15px;
  }
  .message-foot-text {
    display: inline-block;
    padding-right: 15px;
    position: relative;
    bottom: -15px;
    color: #2E3635
  }

  .text-required {
    color: #2E3635
  }
  .button-register {
    margin-right: 10px;
    position: relative;
    top: -40px;
  }
  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder{
    font-weight: bold;
    color: #2E3635
  }

  @media (max-width: 578px) {

  }
</style>
